import './index.scss';
import { EventManager } from 'utils/event_manager';

(function ($) {
  const $component = $('.q-timeline-page');
  const $timelineLoader = $('.js-timeline-loader', $component);

  if ($component) {
    const pageLoaded = (msg, data) => {
      $timelineLoader.removeClass('loading');

      if (data.last) {
        $timelineLoader.hide();
      } else {
        $timelineLoader.show();
      }
    };

    $timelineLoader.click(() => {
      $timelineLoader.addClass('loading');
      EventManager.publish('timeline.page.load');
    });

    EventManager.subscribe('timeline.page.loaded', pageLoaded);
  }
})(jQuery);
